import { ErrorBoundary } from "@sentry/react";
import { Outlet } from "react-router";

import { FullScreenLoader } from "@punto/ui/components/full-screen-loader";

import { RootProvider } from "@/modules/root/components/root-provider";
import { routePaths } from "@/router/route-paths";

import { authenticatedRoutes } from "./authenticated-routes";
import { publicRoutes } from "./public-routes";

export const appRoutes = [
  {
    path: routePaths.base,
    errorElement: <ErrorBoundary />,
    hydrateFallbackElement: <FullScreenLoader />,
    element: (
      <RootProvider>
        <Outlet />
      </RootProvider>
    ),
    children: [...publicRoutes, ...authenticatedRoutes],
  },
];
